import { useState } from "react"
import axiosInstance from "../../services/axios-client"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const useResetPassword = () => {
    const navigate = useNavigate()
    const [payload, setPayload] = useState({})
    const [resetError, setResetError] = useState(false)
    const [resetErrorMessage, setResetErrorMessage] = useState('')
    const onChangeHandler = (e) => {
        setResetError(false)
        setResetErrorMessage('')
        setPayload({ ...payload, [e.target.name]: e.target.value })
    }
    const [loadingPagestate, setLoadingPage] = useState(false)

    const resetPasswordHandler = async (email, resetToken, payload) => {
        try {
            setLoadingPage(true)
            const res = await axiosInstance.patch(`/reset-password/${email}/${resetToken}`, payload)
            if (res.status === 200) {
                setLoadingPage(false)
                toast.success("Reset Password Successfully")
                navigate("/login")
            }
        } catch (error) {
            setLoadingPage(false)
            setResetError(true)
            const errorMsg = error?.response?.data?.message || error.message || 'Reset password failed. Please try again.'
            setResetErrorMessage(errorMsg)
            // Optionally log error details for debugging
            console.error('Reset password error:', errorMsg)
        }
    }

    return {
        payload,
        onChangeHandler,
        resetPasswordHandler,
        loadingPagestate,
        resetError,
        setResetError,
        resetErrorMessage
    }
}

export default useResetPassword